/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.lg-container[_ngcontent-%COMP%]{padding:1rem}.ace-editor[_ngcontent-%COMP%]{margin:1rem;border:1px solid #e9e9e9;min-height:280px;max-height:280px;overflow:hidden}"];
export { styles as styles };
